/**
 * @generated SignedSource<<acbb7cd4d739c80c4a4945857a1ce6c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AccountBalanceQuery$variables = {};
export type AccountBalanceQuery$data = {
  readonly offerHistory: {
    readonly " $fragmentSpreads": FragmentRefs<"OfferHistory_offerHistory">;
  } | null;
  readonly balance: {
    readonly " $fragmentSpreads": FragmentRefs<"Balance_balance">;
  } | null;
  readonly history: {
    readonly " $fragmentSpreads": FragmentRefs<"HistoryCharts_history">;
  } | null;
  readonly userData: {
    readonly currency: {
      readonly currencySymbol: string;
    };
  } | null;
  readonly cashoutProviders: {
    readonly " $fragmentSpreads": FragmentRefs<"CashoutProviderButtons_providers">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"TransactionList_transactions">;
};
export type AccountBalanceQuery = {
  variables: AccountBalanceQuery$variables;
  response: AccountBalanceQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "Currency",
  "kind": "LinkedField",
  "name": "currency",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currencySymbol",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formatted",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "MoneyAmount",
  "kind": "LinkedField",
  "name": "amount",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cents",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "MoneyAmount",
  "kind": "LinkedField",
  "name": "amount",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
},
v11 = [
  (v9/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "label",
    "storageKey": null
  },
  (v10/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountBalanceQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "TransactionList_transactions"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "OfferStatusConnection",
        "kind": "LinkedField",
        "name": "offerHistory",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "OfferHistory_offerHistory"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Balance",
        "kind": "LinkedField",
        "name": "balance",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Balance_balance"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "History",
        "kind": "LinkedField",
        "name": "history",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "HistoryCharts_history"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserData",
        "kind": "LinkedField",
        "name": "userData",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CashoutProviders",
        "kind": "LinkedField",
        "name": "cashoutProviders",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CashoutProviderButtons_providers"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AccountBalanceQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TransactionConnection",
        "kind": "LinkedField",
        "name": "transactions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TransactionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Transaction",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "eventType",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "giftCardId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "transactions(first:20)"
      },
      {
        "alias": null,
        "args": (v1/*: any*/),
        "filters": null,
        "handle": "connection",
        "key": "TransactionList_query_transactions",
        "kind": "LinkedHandle",
        "name": "transactions"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "OfferStatusConnection",
        "kind": "LinkedField",
        "name": "offerHistory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OfferStatusEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OfferStatus",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "guid",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Advertiser",
                    "kind": "LinkedField",
                    "name": "advertiser",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MoneyAmount",
                    "kind": "LinkedField",
                    "name": "pendingAmount",
                    "plural": false,
                    "selections": (v4/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MoneyAmount",
                    "kind": "LinkedField",
                    "name": "approvedAmount",
                    "plural": false,
                    "selections": (v4/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MoneyAmount",
                    "kind": "LinkedField",
                    "name": "rejectedAmount",
                    "plural": false,
                    "selections": (v4/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updatedAt",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Balance",
        "kind": "LinkedField",
        "name": "balance",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "History",
        "kind": "LinkedField",
        "name": "history",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MoneyAmount",
            "kind": "LinkedField",
            "name": "earningTotal",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MoneyAmount",
            "kind": "LinkedField",
            "name": "cashoutTotal",
            "plural": false,
            "selections": (v4/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "HistoryTotalAmount",
            "kind": "LinkedField",
            "name": "earningBreakdown",
            "plural": true,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "HistoryTotalAmount",
            "kind": "LinkedField",
            "name": "cashoutBreakdown",
            "plural": true,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "HistoryMonthlyAmount",
            "kind": "LinkedField",
            "name": "monthlyEarnings",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "date",
                "storageKey": null
              },
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserData",
        "kind": "LinkedField",
        "name": "userData",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CashoutProviders",
        "kind": "LinkedField",
        "name": "cashoutProviders",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CashoutProvider",
            "kind": "LinkedField",
            "name": "providers",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v6/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "45c754bfc72da591142e1014e5f64c3a",
    "id": null,
    "metadata": {},
    "name": "AccountBalanceQuery",
    "operationKind": "query",
    "text": "query AccountBalanceQuery {\n  ...TransactionList_transactions\n  offerHistory {\n    ...OfferHistory_offerHistory\n    id\n  }\n  balance {\n    ...Balance_balance\n    id\n  }\n  history {\n    ...HistoryCharts_history\n    id\n  }\n  userData {\n    currency {\n      currencySymbol\n    }\n    id\n  }\n  cashoutProviders {\n    ...CashoutProviderButtons_providers\n    id\n  }\n}\n\nfragment Balance_balance on Balance {\n  id\n  amount {\n    formatted\n  }\n}\n\nfragment CashoutProviderButtons_providers on CashoutProviders {\n  providers {\n    name\n    status\n    id\n  }\n  id\n}\n\nfragment HistoryCharts_history on History {\n  id\n  status\n  earningTotal {\n    cents\n    formatted\n  }\n  cashoutTotal {\n    formatted\n  }\n  earningBreakdown {\n    type\n    label\n    amount {\n      cents\n      currency\n      formatted\n    }\n  }\n  cashoutBreakdown {\n    type\n    label\n    amount {\n      cents\n      currency\n      formatted\n    }\n  }\n  monthlyEarnings {\n    date\n    type\n    amount {\n      cents\n      currency\n      formatted\n    }\n  }\n}\n\nfragment OfferHistoryItem_offer on OfferStatus {\n  guid\n  title\n  advertiser {\n    name\n  }\n  pendingAmount {\n    formatted\n  }\n  approvedAmount {\n    formatted\n  }\n  rejectedAmount {\n    formatted\n  }\n  updatedAt\n}\n\nfragment OfferHistory_offerHistory on OfferStatusConnection {\n  edges {\n    node {\n      guid\n      ...OfferHistoryItem_offer\n      id\n    }\n  }\n  id\n}\n\nfragment TransactionItem_transaction on Transaction {\n  id\n  createdAt\n  eventType\n  amount {\n    formatted\n  }\n  giftCardId\n  description\n  status\n}\n\nfragment TransactionList_transactions on Query {\n  transactions(first: 20) {\n    edges {\n      node {\n        id\n        ...TransactionItem_transaction\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5f6ec672bc2271c26cc8fa912c558104";

export default node;
